import { useQuery } from '@tanstack/react-query';
import type { AgentApiCustomTagConditionsIndex } from '@/types/serializers';

/**
 * 求職者タグの条件一覧を取得するフック
 * エンドポイントは求人タグと共通（tag_type 非依存）
 */
export default function useFetchTagConditions(tagId: number | null) {
  return useQuery({
    queryKey: ['/agent/api/custom_tags', tagId, 'conditions'],
    queryFn: async () => {
      if (!tagId) return { records: [] };

      const response = await fetch(`/agent/api/custom_tags/${tagId}/conditions`, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch tag conditions');
      }

      const data: AgentApiCustomTagConditionsIndex = await response.json();
      return data;
    },
    enabled: !!tagId,
  });
}
